import React, { useState, useEffect, useMemo } from 'react';
import { useQuizContext } from '../context/QuizContext';

const Results = () => {
  const {
     userData,
     restart,
     quizResult
   } = useQuizContext();
  const [loading, setLoading] = useState(true);
  const [showTermsModal, setShowTermsModal] = useState(false);
  // Definimos los hooks de estado al inicio del componente, no condicionalmente
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  // Colores para mantener consistencia
  const panelBgColor = '#030645'; // Azul oscuro como en el Welcome
  const buttonColor = '#c84357'; // Rojo similar al de los elementos del logo

  // Verificación de seguridad - asegúrate de que quizResult tiene todas las propiedades esperadas
  const descripcion = quizResult ? (quizResult["Descripción"] || "") : "";
  const coctelSugerido = quizResult ? (quizResult["Coctel sugerido"] || "") : "";
  const sugerencia = quizResult ? (quizResult["sugerencia"] || "") : "";
  // Base URL para las imágenes en AWS S3
  const s3BaseUrl = "https://productos-commerk-webp.s3.us-east-2.amazonaws.com/";
console.log("quizResult", sugerencia);
  // Función para obtener el código de la imagen
  const getImageCode = () => {
    if (!quizResult) return "licor-default";
    
    // Primero intentamos usar el código explícito si existe
    if (quizResult.codigo) {
      // Asegurarnos de que no tenga espacios
      return quizResult.codigo.replace(/\s+/g, '_');
    }
    if (quizResult.código) {
      // Asegurarnos de que no tenga espacios
      return quizResult.código.replace(/\s+/g, '_');
    }
    
    // Si no hay código, intentamos formatear el tipo de licor
    
    // Si todo falla, devolvemos un valor por defecto
    return "licor-default";
  };
  
  // Generamos el código del licor
  const licorCode = getImageCode();
  
  // Lista de posibles formatos de imagen para intentar usando useMemo
  const imageVariants = useMemo(() => [
    `${s3BaseUrl}${licorCode}.webp`,
    `${s3BaseUrl}${licorCode.replace(/_/g, '-')}.webp`,
    `${s3BaseUrl}${licorCode.toLowerCase()}.webp`,
    `${s3BaseUrl}${licorCode.replace(/_/g, ' ').toLowerCase()}.webp`,
    `${s3BaseUrl}licor-default.webp`
  ], [licorCode, s3BaseUrl]);
  console.log("imageVariants", imageVariants);
  // Obtenemos el nombre del usuario desde la respuesta del webhook o desde userData
  const fullName = quizResult && quizResult.nombre ? quizResult.nombre : (userData ? userData.name : "");
  
  // Extraemos solo el primer nombre (primera palabra)
  const firstName = fullName ? fullName.split(' ')[0] : "";

  // Actualizamos la URL de la imagen cuando cambia el código del licor
  useEffect(() => {
    if (licorCode) {
      setCurrentImageUrl(imageVariants[0]);
    }
  }, [licorCode, imageVariants]);


  const tipoLicor = useMemo(() => {
    // Mapa de códigos a nombres de licores
    const licorMap = {
      "tradicional": "Ron Tradicional",
      "esencial": "Licor Esencial",
      "carta_de_oro": "Ron Carta de Oro",
      "juan_cruz": "Ron Juan Cruz",
      "gran_reserva": "Ron Gran Reserva Especial",
      "oscuro": "Ron Oscuro",
      "roble_blanco": "Ron Roble Blanco",
      "molendero": "Molendero",
      "cheers": "Cheers"
    };
  const licorAux= quizResult ? (quizResult["Tipo de licor"] || "") : "";
    // Retorna el nombre del licor si existe en el mapa, o un valor por defecto
    return licorMap[licorCode] ||  licorAux
  }, [licorCode, quizResult]);
  
  



  // Efecto para el tiempo de carga
  useEffect(() => {
    // Simulamos un pequeño retraso para mostrar la pantalla de carga
    const timer = setTimeout(() => {
      // No necesitamos hacer una llamada a la API aquí, ya que los resultados
      // ya se obtuvieron en el paso anterior (submitAnswers en QuizContext)
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Función segura para personalizar la descripción
  const getPersonalizedDescription = (desc, name) => {
    if (!desc) return "";
    if (!name) return desc;
    
    // Intentamos reemplazar patrones comunes con el nombre
    try {
      if (desc.includes("Eres una persona")) {
        return desc.replace("Eres una persona", `${name}, eres una persona`);
      } else if (desc.includes("Vos sos")) {
        return desc.replace("Vos sos", `${name}, vos sos`);
      } else if (desc.startsWith("Eres")) {
        return desc.replace("Eres", `${name}, eres`);
      } else {
        // Si no encontramos un patrón conocido, simplemente añadimos el nombre al principio
        return `${name}, ${desc.charAt(0).toLowerCase()}${desc.slice(1)}`;
      }
    } catch (error) {
      console.error("Error al personalizar descripción:", error);
      return desc;
    }
  };

  // Manejar errores de carga de imagen
  const handleImageError = () => {
    // Encontrar el índice actual en las variantes
    const currentIndex = imageVariants.indexOf(currentImageUrl);
    
    // Si hay más variantes para probar
    if (currentIndex < imageVariants.length - 1) {
      const nextUrl = imageVariants[currentIndex + 1];
      console.log(`Intentando cargar imagen alternativa: ${nextUrl}`);
      setCurrentImageUrl(nextUrl);
    } else {
      // Si ya probamos todas las variantes, mostramos un mensaje en la consola
      console.error("No se pudo cargar ninguna variante de imagen para", licorCode);
    }
  };

  if (!quizResult) {
    return (
      <div 
        className="flex items-center justify-center min-h-screen p-4"
        style={{
          backgroundImage: 'url(/assets/images/background.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div 
          className="max-w-md w-full rounded-xl shadow-lg bg-opacity-90 p-8"
          style={{ backgroundColor: panelBgColor }}
        >
          {/* Logo dentro del panel azul - espacio reducido */}
          <div className="flex justify-center mt-2">
            <img 
              src="/assets/logos/logo3.jpeg" 
              alt="COMMERK s.a.s." 
              className="h-40"
            />
          </div>
          
          <div className="text-center mt-0">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-red-500 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-2xl font-bold mb-2 text-white">Ha ocurrido un error</h2>
            <p className="mb-4 text-white opacity-80">No pudimos obtener tus resultados. Por favor, inténtalo de nuevo.</p>
            <button
              onClick={restart}
              className="rounded-full shadow-md transition-all duration-300 hover:shadow-lg text-white font-bold py-3 px-6"
              style={{ backgroundColor: buttonColor }}
            >
              Finalizar experiencia
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="flex flex-col items-center justify-center min-h-screen p-4"
      style={{
        backgroundImage: 'url(/assets/images/background.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div 
        className="max-w-4xl w-full rounded-xl shadow-lg bg-opacity-90 p-6"
        style={{ backgroundColor: panelBgColor }}
      >
        {/* Logo dentro del panel azul - espacio reducido */}
        <div className="flex justify-center mt-2">
          <img 
            src="/assets/logos/logo3.jpeg" 
            alt="COMMERK s.a.s." 
            className="h-40"
          />
        </div>

        <div className="text-center mb-4 mt-0">
          {firstName ? (
            <h1 className="text-4xl font-bold mb-2 text-[#ff5733]">¡{firstName}, tu licor ideal es!</h1>
          ) : (
            <h1 className="text-4xl font-bold mb-2 text-white">¡Tu licor ideal es!</h1>
          )}
          <div className="w-32 h-1 mx-auto" style={{ backgroundColor: buttonColor }}></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Imagen del licor */}
          <div className="flex justify-center items-center">
            <div className="relative">
              <img
                key={currentImageUrl} // Importante: fuerza re-renderizado cuando cambia la URL
                src={currentImageUrl}
                alt={tipoLicor}
                className="rounded-lg max-h-80 object-contain"
                onError={handleImageError}
              />
            </div>
          </div>
          
          {/* Descripción del licor */}
          <div>
            <h2 className="text-4xl font-bold mb-4 text-white">{tipoLicor}</h2>
            
            <p className="text-lg mb-4 text-white ">
              {getPersonalizedDescription(descripcion)}
            </p>
            {sugerencia && (<>
              <h3 className="text-xl font-semibold mb-2 text-white">Recomendación:</h3>
              <p className="text-lg mb-4 text-white ">{sugerencia}</p>
              </>)}
            <h3 className="text-xl font-semibold mb-2 text-white">Cóctel sugerido:</h3>
            <p className="mb-4 text-lg text-white ">
              {coctelSugerido}
            </p>
            
            
            {/* Social media icons properly aligned */}
            
            <div className="flex justify-center">
              <button
                className="rounded-full shadow-md transition-all duration-300 hover:shadow-lg text-white font-bold py-3 px-6"
                style={{ backgroundColor: buttonColor }}
                onClick={restart}
              >
                Finalizar experiencia
              </button>
            </div>
            <div className="flex items-center justify-center space-x-5 mt-4">
              <div className="flex flex-col items-center">
                <p className='text-white mt-3'>Sigue nuestras redes.</p>
                <p className='text-white'>haz click aqui </p>
                </div>
                <div className='space-x-4 mt-2 flex'>
              <a href="https://www.facebook.com/kstorevalle/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/logos/Facebook_Logo_Primary.webp" alt="Facebook Commerk" className="h-10 w-10 hover:opacity-80 transition-opacity" />
              </a>
              <a href="https://www.instagram.com/tiendacommerk/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/logos/Instagram.webp" alt="Instagram Commerk" className="h-10 w-10 hover:opacity-80 transition-opacity" />
              </a>
              </div>
            </div>
          </div>
          </div>

          {/* Sección de agradecimiento */}
        <div className="mt-8 text-center text-white">
          <h3 className="text-xl font-semibold mb-2">
            {firstName ? `¡Gracias por participar!` : '¡Gracias por participar!'}
          </h3>
          {/* <p className="opacity-90 mb-2">
            Visita nuestro stand en la feria para probar {tipoLicor} y descubrir toda nuestra selección de licores premium.
          </p> */}
          
          {/* Enlace al sitio web y términos y condiciones */}
          <div className="flex flex-col items-center space-y-2 mt-2">
            <a 
              href="https://tiendacommerkvalle.com.co/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white underline hover:text-gray-300 transition-colors"
            >
              Visítanos en nuestra tienda online
            </a>
            
            <button 
              onClick={() => setShowTermsModal(true)} 
              className="text-white underline text-sm hover:text-gray-300"
              style={{ color: "#eae7e7" }}
            >
              Términos y Condiciones
            </button>
          </div>
        </div>
      </div>
      
      {/* Modal de Términos y Condiciones con formato mejorado */}
      {showTermsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-lg w-full max-h-screen overflow-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Términos y Condiciones</h2>
                <button 
                  onClick={() => setShowTermsModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
              <div className="terms-content">
                <h3 className="text-lg font-bold text-center mb-4 bg-blue-100 py-2 px-4 rounded-md">Términos y Condiciones de Uso – App de Recomendación de Licores</h3>
                
                <p className="mb-4">
                  Esta aplicación es desarrollada y operada por <strong>Commerk S.A.S.</strong>, empresa distribuidora
                  autorizada de productos de la <strong>Industria Licorera de Caldas</strong>. Su finalidad es brindar
                  recomendaciones de licores utilizando inteligencia artificial, con base en el portafolio
                  disponible de nuestra empresa.
                </p>
                
                <p className="mb-4">
                  Las sugerencias generadas por la aplicación son de carácter orientativo y no constituyen
                  asesoría profesional. Pueden no considerar factores personales, de salud o contextuales del
                  usuario, y podrían contener imprecisiones o errores ocasionales. <strong>Commerk S.A.S.</strong> no
                  garantiza la precisión absoluta de las recomendaciones ni se hace responsable por las
                  decisiones de consumo basadas en ellas.
                </p>
                
                <p className="mb-4">
                  El uso de esta app es voluntario y bajo responsabilidad exclusiva del usuario. Al utilizarla, el
                  usuario acepta expresamente estas condiciones.
                </p>
                
                <p className="mb-6 font-bold bg-yellow-100 py-2 px-4 rounded-md text-center">
                  Consuma con moderación. Prohibido el expendio de bebidas embriagantes a
                  menores de edad.
                </p>
                
                <h3 className="text-lg font-bold mb-4 bg-blue-100 py-2 px-4 rounded-md">Derechos de Uso y Propiedad Intelectual</h3>
                
                <p className="mb-4">
                  Todo el contenido de esta aplicación—incluidos pero no limitado a textos, descripciones de
                  productos, logotipos, imágenes, interfaz de usuario y recomendaciones generadas por
                  inteligencia artificial de uso comercial.
                </p>
                
                <p className="mb-4">
                  Está prohibida la reproducción, distribución, modificación o uso del contenido para fines
                  comerciales o no autorizados, sin el consentimiento expreso y por escrito de <strong>Commerk
                  S.A.S.</strong> o del respectivo titular de los derechos.
                </p>
                
                <p className="mb-4">
                  El modelo de inteligencia artificial incorporado en esta app es una herramienta de apoyo
                  interactiva y no sustituye el juicio humano ni el consumo informado y responsable.
                </p>
              </div>
              <div className="mt-6 flex justify-end">
                <button 
                  onClick={() => setShowTermsModal(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Results;